import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
export default {
  mounted() {
    this.fetchcommunity_assets();
    this.get_community_assets_category();
    this.fetch_my_bookings();
    const userDetails = get_user_details();
    this.current_user_id = parseInt(userDetails.user_id, 10);
    this.current_role = userDetails.user_role;
    document.addEventListener('click', this.handle_click_outside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handle_click_outside);
  },

  components: {
    HomeNavBar
  },
  data() {
    return ({
      asset_name:'',
      description:'',
      isEditing:false,
      location:'',
      category_id:'',
      isSubmitting: false,
      upload_media: null,
      community_assets: [],
      community_asset_categories: [],
      isLoading: false,
      errors: {},
      selected_asset:{},
      asset_id: null,
      temporary_asset_post : null,
      asset_file_name:'',
      current_user_id: null,
      current_role: '',
      booking_start_date: '',
      booking_start_time: '',
      booking_end_time: '',
      booking_reason: '',
      booking_ranges: [],
      booking_submitting: false,
      booking_asset: {},
      booked_slots: [],
      activeTab: 'assets',
      my_bookings: [],
      show_date_error: false,
      calendar_popover_id: null,



    });
  },
  watch: {
    booking_start_date(newVal) {
      if (newVal) {
        this.show_date_error = false;
      }
    }
  },

  computed: {
    available_time_slots() {
      if (!this.booking_start_date) return [];

      const selected_date = this.booking_start_date;

      const day_bookings = this.booked_slots.filter(slot => {
        const slot_date = new Date(slot.booking_start_date).toISOString().slice(0, 10);
        const is_not_cancelled_or_rejected = slot.status !== 'cancelled' && slot.status !== 'rejected';
        return slot_date === selected_date && is_not_cancelled_or_rejected;
      });

      const booked_ranges = day_bookings.map(slot => ({
        start: this.time_to_minutes(slot.booking_start_time),
        end: this.time_to_minutes(slot.booking_end_time),
      }));

      const full_slots = this.generateFullTimeSlots();

      return full_slots.filter(time => {
        const time_in_mins = this.time_to_minutes(time);
        const end_time_in_mins = time_in_mins + 30;

        return !booked_ranges.some(range =>
          time_in_mins < range.end && end_time_in_mins > range.start
        );
      });
    },

    grouped_Bookings() {
      const map = new Map();
    
      if (!Array.isArray(this.my_bookings)) return [];
    
      this.my_bookings.forEach((booking) => {
        if (!booking) return;
    
        const rawId = booking.asset_id ?? booking.asset;
        if (!rawId) return; // Skip if asset_id is still undefined/null
    
        const assetId = String(rawId).replace(/[^a-zA-Z0-9_-]/g, '');
        const safeBooking = { ...booking };
    
        if (!map.has(assetId)) {
          map.set(assetId, {
            assetId,
            latest: { ...safeBooking },
            all: [safeBooking],
          });
        } else {
          const group = map.get(assetId);
          group.all.push(safeBooking);
    
          const latest = group.latest;
          const currentLatest = new Date(`${latest.booking_start_date}T${latest.booking_start_time}`);
          const currentBooking = new Date(`${safeBooking.booking_start_date}T${safeBooking.booking_start_time}`);
    
          if (currentBooking > currentLatest) {
            group.latest = { ...safeBooking };
          }
        }
      });
    
      // Sort each group’s bookings by start date descending
      for (const group of map.values()) {
        group.all.sort((a, b) =>
          new Date(`${b.booking_start_date}T${b.booking_start_time}`) -
          new Date(`${a.booking_start_date}T${a.booking_start_time}`)
        );
      }
    
      return Array.from(map.values());
    }
  },
  methods: {
    toggle_calendar_popover(assetId) {
      if (this.calendar_popover_id === assetId) {
        this.calendar_popover_id = null;
      } else {
        this.calendar_popover_id = assetId;
      }
    },
    handle_click_outside(event) {
      if (!this.calendar_popover_id) return;
      // Get the popover ref for the currently active calendar_popover_id
      const popover = this.$refs[`calendarPopover${this.calendar_popover_id}`];
      // Vue refs inside v-for with same ref attribute name become arrays,
      // so ensure you get the DOM node:
      const popoverEl = Array.isArray(popover) ? popover[0] : popover;
      if (popoverEl && !popoverEl.contains(event.target)) {
        this.calendar_popover_id = null;
      }
    },

    export_bookings_CSV() {
      if (!this.booked_slots.length) return;

      const headers = ['Name', 'Booking Date', 'Start Time', 'End Time', 'Status'];
      const rows = this.booked_slots.map(b => [
        b.user.profile_name,
        b.booking_start_date,
        this.formatTime(b.booking_start_time),
        this.formatTime(b.booking_end_time),
        b.status
      ]);

      const csv_content = [headers, ...rows]
        .map(e => e.join(','))
        .join('\n');

      const blob = new Blob([csv_content], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `bookings_${this.selected_asset.name}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    show_my_bookings() {
      this.activeTab = 'bookings';
      this.fetch_my_bookings()
    },
    get_slot_class(time) {
      if (!this.booking_start_date) {
        return {};
      }
  
      const is_unavailable = !this.available_time_slots.includes(time) || this.is_booked_time_slot(time);
      const is_past = this.is_past_time_slot(time);
      const is_selected = this.booking_start_time === time || this.booking_end_time === time;
      const is_in_range = this.is_in_range(time);
      const is_booked_range = this.is_booked_range(time);
  
      return {
        'unavailable': is_unavailable && !is_past,
        'past-slot': is_past,
        'selected': is_selected || is_booked_range,
        'in-range': is_in_range && !is_booked_range
      };
    },
    is_in_range(time) {
      if (!this.booking_start_time || !this.booking_end_time) return false;
    
      const start_time_in_mins = this.time_to_minutes(this.booking_start_time);
      const end_time_in_mins = this.time_to_minutes(this.booking_end_time);
      const time_in_mins = this.time_to_minutes(time);
    
      return time_in_mins > start_time_in_mins && time_in_mins < end_time_in_mins;
    },


    is_booked_time_slot(time) {
      const time_in_mins = this.time_to_minutes(time);
      return this.booked_slots.some(slot => {
        const is_same_date = slot.booking_start_date === this.booking_start_date;
        const status = slot.status?.toLowerCase();
        const is_not_cancelled_or_rejected = status !== 'cancelled' && status !== 'rejected';
    
        return is_same_date && is_not_cancelled_or_rejected &&
               time_in_mins >= this.time_to_minutes(slot.booking_start_time) &&
               time_in_mins <= this.time_to_minutes(slot.booking_end_time);
      });
    },

    is_past_time_slot(time) {
      if (!this.booking_start_date) return false;

      const today = new Date().toISOString().slice(0, 10);
      const selected_date = this.booking_start_date;

      const now = new Date();
      // If the selected date is before today, all time slots are past
      if (selected_date < today) return true;

      // If selected date is today, compare times
      if (selected_date === today) {
        const [hours, minutes] = time.split(':').map(Number);
        const slotTime = new Date();
        slotTime.setHours(hours, minutes, 0, 0);
        return slotTime < now;
      }

      // Future date: not past
      return false;
    },

    is_booked_range(time) {
      return this.booking_ranges.some(range => {
        const start_time_in_mins = this.time_to_minutes(range.start);
        const end_time_in_mins = this.time_to_minutes(range.end);
        const time_in_mins = this.time_to_minutes(time);

        return time_in_mins >= start_time_in_mins && time_in_mins <= end_time_in_mins;
      });
    },

    is_time_selection_invalid(time) {
      return this.is_past_time_slot(time) ||
             this.is_booked_time_slot(time) ||
             !this.available_time_slots.includes(time);
    },


    toggle_time_selection(time) {
      if (!this.booking_start_date) {
        this.show_date_error = true;
        return;
      } else {
        this.show_date_error = false;
      }
      if (this.is_time_selection_invalid(time)) return;

      const existing_range = this.booking_ranges.find(range => {
        const start_time_in_mins = this.time_to_minutes(range.start);
        const end_time_in_mins = this.time_to_minutes(range.end);
        const time_in_mins = this.time_to_minutes(time);

        return time_in_mins >= start_time_in_mins && time_in_mins <= end_time_in_mins;
      });

      if (existing_range) {
        this.booking_ranges = this.booking_ranges.filter(range => range !== existing_range);
        if (this.booking_ranges.length === 0) {
          this.booking_start_time = '';
          this.booking_end_time = '';
        }
      } else if (!this.booking_start_time) {
        this.booking_start_time = time;
      } else if (!this.booking_end_time) {
        if (this.time_to_minutes(time) > this.time_to_minutes(this.booking_start_time)) {
          this.booking_end_time = time;
          this.booking_ranges.push({
            start: this.booking_start_time,
            end: this.booking_end_time,
          });
          this.booking_start_time = '';
          this.booking_end_time = '';
        } else {
          this.booking_start_time = time;
          this.booking_end_time = '';
        }
      } else {
        this.booking_start_time = time;
        this.booking_end_time = '';
      }
    },

    openBookingModal(asset) {
      this.booking_asset = asset;
      this.fetch_bookings(asset.id);

      // First hide the asset modal
      $('#assetModal').modal('hide');

      // After it's fully hidden, then show the booking modal
      $('#assetModal').on('hidden.bs.modal', () => {
        $('#bookingModal').modal('show');
        // Remove the event listener after it's used to avoid duplicate triggers
        $('#assetModal').off('hidden.bs.modal');
      });
    },

    time_to_minutes(timeStr) {
      const [hours, minutes] = timeStr.split(':').map(Number);
      return hours * 60 + minutes;
    },

    // Generate time slots in 30-min intervals
    generateFullTimeSlots() {
      const slots = [];
      let start = 8 * 60; // 8:00 AM
      let end = 18 * 60;  // 6:00 PM

      for (let mins = start; mins <= end; mins += 30) {
        const h = String(Math.floor(mins / 60)).padStart(2, '0');
        const m = String(mins % 60).padStart(2, '0');
        slots.push(`${h}:${m}`);
      }
      return slots;
    },

    formatTime(timeStr) {
      if (!timeStr) return '';
      const [hour, minute] = timeStr.split(':').map(Number);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      const hour12 = hour % 12 || 12;
      return `${hour12}:${minute.toString().padStart(2, '0')}${ampm}`;
    },

    submit_booking() {
      if (this.booking_submitting) return;
      this.booking_submitting = true;

      const bookings = this.booking_ranges.map(range => ({
        start_time: range.start,
        end_time: range.end,
      }));
      let pendingBookings = bookings.length;

      const finish_booking_request = () => {
        pendingBookings -= 1;
        if (pendingBookings <= 0) {
          this.booking_submitting = false;
        }
      };

      const submit_booking = (booking) => {
        const start_date = this.booking_start_date;
        const start_time = booking.start_time;
        const end_time = booking.end_time;

        const now = new Date();
        const start_date_time = new Date(`${start_date}T${start_time}`);
        const end_date_time = new Date(`${start_date}T${end_time}`);

        // Validate future dates
        if (start_date_time < now || end_date_time < now) {
          Swal.fire({
            title: 'Invalid',
            text: 'Booking times must be in the future.',
            icon: 'warning',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          this.booking_submitting = false;
          return;
        }

        // Validate time range
        if (start_date_time >= end_date_time) {
          Swal.fire({
            title: 'Invalid',
            text: 'Start time must be before end time.',
            icon: 'warning',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          this.booking_submitting = false;
          return;
        }

        // Check for overlapping bookings
        const is_over_lapping = this.booked_slots.some(slot => {
          const is_same_date = slot.booking_start_date === start_date;
          const is_not_cancelled_or_rejected = slot.status?.toLowerCase() !== 'cancelled' && slot.status?.toLowerCase() !== 'rejected';
          if (!is_same_date || !is_not_cancelled_or_rejected) return false;

          const existingStart = new Date(`${slot.booking_start_date}T${slot.booking_start_time}`);
          const existingEnd = new Date(`${slot.booking_start_date}T${slot.booking_end_time}`);
          return start_date_time < existingEnd && end_date_time > existingStart;
        });

        if (is_over_lapping) {
          Swal.fire({
            title: 'Conflict',
            text: 'This time slot is already booked.',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          this.booking_submitting = false;
          return;
        }

        const formData = new FormData();
        formData.append('community_asset_id', this.booking_asset.id);
        formData.append('booking_start_date', start_date);
        formData.append('booking_start_time', start_time);
        formData.append('booking_end_time', end_time);
        formData.append('booking_reason', this.booking_reason);

        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_booking_asset/`,
          headers: {
            'Authorization': `Token ${this.getToken()}`,
          },
          data: formData,
          processData: false,
          contentType: false,
          success: (response) => {
            if (response.status === "success") {
              const message = this.current_role === 'admin'
                ? 'Booking created successfully.'
                : 'Your booking has been submitted and is pending admin approval.';
              Swal.fire({
              icon: 'success',
              title: 'Success',
              text:  message|| response.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
              }).then(() => {
              if (bookings.indexOf(booking) === bookings.length - 1) {
                $('#bookingModal').modal('hide');
                this.booking_start_date = '';
                this.booking_start_time = '';
                this.booking_end_time = '';
                this.booking_ranges = [];
                this.my_bookings.unshift(response.data);
              }
            });
            } else {
              Swal.fire({
                title: 'Error',
                text: response.message || 'Could not complete booking.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          },
          error: (response) => {
            const response_data = response.responseJSON;
            Swal.fire({
              title: 'Error',
              text: response_data?.message || 'Booking failed.',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          },
          complete: () => {
            finish_booking_request();
          }
        });
      };
    
      bookings.forEach(booking => {
        submit_booking(booking);
      });
    },

    view_bookings(asset) {
      this.selected_asset = asset;
      this.fetch_bookings(asset.id);
    },

    fetch_bookings(assetId) {
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_asset_bookings/${assetId}/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`
        },
        success: (response) => {
          this.booked_slots = response;
        },
        error: (xhr) => {
          console.error('Failed to fetch booked slots:', xhr.responseText || xhr.statusText);
        }
      });
    },

    fetch_my_bookings() {
      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_my_bookings/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`
        },
        success: (response) => {
          this.my_bookings = response;
        },
        error: (xhr) => {
          console.error('Failed to fetch your bookings:', xhr.responseText || xhr.statusText);
        }
      });
    },
    cancel_booking(bookingId) {
      Swal.fire({
        title: 'Cancel Booking?',
        text: "Do you really want to cancel this booking?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, cancel it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (!result.isConfirmed) return;

        fetch(`${process.env.VUE_APP_BACKEND_API_URL}/portal_management/cancel_booking/${bookingId}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.getToken()}`
          }
        })
        .then(async res => {
          const data = await res.json();

          if (res.ok && data.status === 'success') {
            Swal.fire({
              title: 'Cancelled!',
              text: data.message || 'Booking cancelled successfully.',
              icon: 'success',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
            
            const booking = this.booked_slots.find(b => b.id === bookingId);
            if (booking) {
              Object.assign(booking, { status: 'cancelled' });
            }
          } else {
            Swal.fire({
              title: 'Error',
              text: data.message || data.detail || 'Failed to cancel.',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        })
        .catch(err => {
          console.error('Cancel booking failed:', err);
          Swal.fire({
            title: 'Error',
            text: 'Something went wrong while cancelling.',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        });
      });
    },

    approve_booking(bookingId) {
      Swal.fire({
        title: 'Approve Booking?',
        text: "Do you want to approve this booking?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#198754',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, approve it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/approve_booking/${bookingId}/`,
            headers: {
              'Authorization': `Token ${this.getToken()}`
            },
            success: (data) => {
              if (data.message === "Booking approved successfully.") {
                const booking = this.booked_slots.find(booking => booking.id === bookingId);
                if (booking) {
                  this.booked_slots = this.booked_slots.map(b => b.id === bookingId ? { ...b, status: data.status } : b);
                }
                Swal.fire({
                  title: 'Approved!',
                  text: data.message,
                  icon: 'success',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              } else {
                Swal.fire({
                  title: 'Error',
                  text: data.error || 'Failed to approve booking.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
               }
            },
            error: (xhr) => {
              console.error('Approve booking failed:', xhr.responseText || xhr.statusText);
            }
          });
        }
      });
    },

    reject_booking(bookingId) {
      Swal.fire({
        title: 'Reject Booking?',
        text: "Are you sure you want to reject this booking?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545', // Bootstrap danger red
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, reject it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reject_booking/${bookingId}/`,
            headers: {
              'Authorization': `Token ${this.getToken()}`
            },
            success: (data) => {
              if (data.message === "Booking rejected successfully.") {
                const booking = this.booked_slots.find(booking => booking.id === bookingId);
                if (booking) {
                  this.booked_slots = this.booked_slots.map(b => b.id === bookingId ? { ...b, status: data.status } : b);
                }
                Swal.fire({
                  title: 'Rejected!',
                  text: data.message,
                  icon: 'success',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              } else {
                Swal.fire({
                  title: 'Error',
                  text: data.error || 'Failed to reject booking.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            },
            error: (xhr) => {
              console.error(xhr.responseText);
              Swal.fire({
                title: 'Error',
                text: 'Something went wrong.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },


    getToken() {
      return get_token();
    },
    fetchcommunity_assets() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_community_asset/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (data) => {

          this.community_assets = data.community_assets;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleAssetFileUpload(event) {

      const file = event.target.files[0];

      if (file) {
        if (file.type.startsWith("audio/")) {
          this.upload_media = null;
          this.asset_file_name = "";
          event.target.value = "";
        } else {
          this.asset_file_name = file.name;
          this.upload_media = file;
        }
      } else {
        this.asset_file_name = "";
        this.upload_media = null;
      }
    },

    createcommunity_asset() {
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('name', this.asset_name);
      formData.append('description', this.description);
      formData.append('location', this.location);
      formData.append('category_id', this.category_id);
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_community_asset/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          const status = response.status;
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Community asset Created Successfully',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              window.location.reload();
              $('#create_community_asset_modal').modal('hide');
            });
          }
        },
        error: (response) => {
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.community_asset_name = response_data.message
          }
        },
        complete: () => {
          this.isEditing = false;
          this.isSubmitting = false;
        }
      });
    },

    get_community_assets_category() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_community_assets_category/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.community_asset_categories = response.data.categories;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    select_asset(asset) {
      this.selected_asset = asset;
      this.fetch_bookings(asset.id);
    },
    subscribeCommunityAsset(communityAsset) {
      const communityAssetId = communityAsset.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/subscribe_community_asset/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ community_asset_id: communityAssetId }),
        success: (response) => {
          if (response.status === "success") {
            communityAsset.subscribed = true;

            const subscribeButton = $(`#subscribe-button${communityAssetId}`);
            const subscribedButton = $(`#subscribed-button${communityAssetId}`);

            if (subscribeButton.length) {
              subscribeButton.addClass('d-none');
            }

            if (subscribedButton.length) {
              subscribedButton.removeClass('d-none');
            }
          }
        },
      });
    },
    unsubscribeCommunityAsset(communityAsset) {
      const communityAssetId = communityAsset.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/subscribe_community_asset/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ community_asset_id: communityAssetId }),
        success: (response) => {
          if (response.status === "success") {
            communityAsset.subscribed = false;

            const subscribeButton = $(`#subscribe-button${communityAssetId}`);
            const subscribedButton = $(`#subscribed-button${communityAssetId}`);

            if (subscribeButton.length) {
              subscribeButton.removeClass('d-none');
            }

            if (subscribedButton.length) {
              subscribedButton.addClass('d-none');
            }
          }
        },
      });
    },
    delete_asset(community_asset_id) {

      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "DELETE",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_community_asset/`,
            data: {
              community_asset_id: community_asset_id
            },
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The Asset has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  this.community_assets = this.community_assets.filter(asset => asset.id !== community_asset_id);
                });
              } else {
                Swal.fire({
                  title: 'Failed!',
                  text: response.message || 'An error occurred. Please try again.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            },
            error: (xhr) => {
              const response = xhr.responseJSON;
              Swal.fire({
                title: 'Failed!',
                text: response.message || 'An error occurred. Please try again.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    open_create_modal() {
      this.isEditing = false;
      this.asset_id = null;
      this.asset_name = '';
      this.location = '';
      this.description = '';
      this.category_id = null;
      this.upload_media = null;
      this.errors = {};
      $('#create_community_asset_modal').modal('show');
    },

    edit_asset(asset) {
      this.asset_id = asset.id;
      this.isEditing = true;
      this.asset_name = asset.name;
      this.location = asset.location;
      this.description = asset.description;
      this.category_id = asset.category.id;

      $('#create_community_asset_modal').modal('show');
    },

    updateCommunityAsset() {
      $('#create_community_asset_modal').modal('hide');

      this.temporary_asset_post = {
        asset_name: this.asset_name,
        isTemp: true,
      };
      // Create FormData to send the file and other fields
      this.isLoading = true;
      const formData = new FormData();
      formData.append('community_asset_id', this.asset_id);
      formData.append('community_asset_name', this.asset_name);
      formData.append('location', this.location);
      formData.append('description', this.description);
      formData.append('category_id', this.category_id);

      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }


      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_community_asset/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        contentType: false,
        processData: false,
        data: formData,
        success: (response) => {
          if (response.status === "success") {
                this.temporary_asset_post= null;
            Swal.fire({
              icon: 'success',
              title: 'Asset Updated',
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#edit_asset').modal('hide');
              this.community_assets.forEach(asset => {
                if (asset.id === this.asset_id) {
                  asset.name = this.asset_name;
                  asset.location = this.location;
                  asset.description = this.description
                  asset.category = this.community_asset_categories.find(cat => cat.id === this.category_id) || asset.category;
                }
              });


            });
          }
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            title: 'Update Failed',
            text: 'There was an error updating the asset.',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },


  },
}
